<template>
  <div class="number-info">
    <div class="number">{{ formatNumber(number) }}</div>
    <div class="label">{{ label }}</div>
  </div>
</template>

<script>
import { formatNumber } from "@/helpers/numberUtils.js"

export default {
  name: "NumberInfo",
  props: {
    number: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "gray",
    },
  },
  data() {
    return {
      formatNumber,
    }
  },
}
</script>

<style lang="scss" scoped>
.number-info {
  width: 100%;
  padding: 1rem;
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .number {
    font-size: 2.5rem;
    font-weight: 600;
    padding-bottom: 0.5rem;
    color: cornflowerblue;
  }
}
</style>
